import { Component } from "preact";
import { css } from "emotion";

const menuHighlight = css({
  width: "100%",
  height: 3,
  backgroundColor: "#6621c0"
});

class TabMenu extends Component {
  changeTab = index => {
    this.setState({
      currentTab: index
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      currentTab: this.props.defaultTab
    };
  }

  render() {
    const { tabs } = this.props;
    const { currentTab } = this.state;

    const menuItem = css({
      fontSize: 26,
      margin: "0px 12px",
      "@media(max-width: 600px)": {
        fontSize: tabs.length === 2 ? 18 : 16
      },
      position: "relative",
      "&:hover": {
        textDecoration: "none",
        cursor: "pointer"
      }
    });

    const menuWrapper = css({
      display: "flex",
      justifyContent: "center",
      margin: "0 auto",
      marginBottom: 30
    });
    return (
      <div>
        <div className={menuWrapper}>
          {tabs.map((tab, index) => (
            <div>
              <a
                className={menuItem}
                style={{ fontWeight: currentTab === index ? 600 : "normal" }}
                onClick={() => this.changeTab(index)}
                aria-selected={index === currentTab}
                aria-controls={`${tab.heading}-tab`}
                id={tab.heading}
              >
                {tab.tabHeading}
              </a>
              {currentTab === index ? <div className={menuHighlight} /> : null}
            </div>
          ))}
        </div>
        <div
          tabIndex={0}
          role="tabpanel"
          id={`${tabs[currentTab].heading}-tab`}
          aria-label={tabs[currentTab].heading}
        >
          {tabs[currentTab].content}
        </div>
      </div>
    );
  }
}

export default TabMenu;
